module.exports = __webpack_public_path__ + "img/play-icon.4d28fa72.svg";